var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZwan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 52,
    viewBox: "0 0 70 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6728 0.482422H0.0141602V14.1411H13.6728V0.482422Z",
    fill: "#0874BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7817 0.482422H16.123V14.1411H29.7817V0.482422Z",
    fill: "#0874BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8881 0.482422H32.2295V14.1411H45.8881V0.482422Z",
    fill: "#0874BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.997 0.482422H48.3384V14.1411H61.997V0.482422Z",
    fill: "#0874BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6728 35.0957H0.0141602V48.7544H13.6728V35.0957Z",
    fill: "#46B7E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7817 35.0957H16.123V48.7544H29.7817V35.0957Z",
    fill: "#46B7E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8881 35.0957H32.2295V48.7544H45.8881V35.0957Z",
    fill: "#46B7E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.997 35.0957H48.3384V48.7544H61.997V35.0957Z",
    fill: "#46B7E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78556 28.7924H12.1618V31.9265H0V28.954L7.217 20.4744H0.501278V17.4199H11.8972V20.5541L4.78556 28.7924Z",
    fill: "#CE1422"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.421 31.9261H25.5724L23.3541 21.3478H23.3002L21.082 31.9261H17.2334L13.2231 17.4219H17.2053L19.4235 27.8363H19.4774L21.4825 17.4219H25.2515L27.3901 27.8363H27.444L29.6622 17.4219H33.5108L29.421 31.9261Z",
    fill: "#CE1422"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0214 29.0928C46.0214 30.8098 46.4009 31.1916 46.8623 31.3555V31.9271H42.7631C42.5453 31.2455 42.4914 31.0276 42.4094 30.2101C41.5404 31.1096 40.32 32.3089 37.741 32.3089C35.5695 32.3089 33.3442 31.0815 33.3442 28.0832C33.3442 25.2489 35.1362 23.8036 37.5512 23.4475L40.9712 22.9299C41.5685 22.8479 42.3017 22.6019 42.3017 21.7844C42.3017 20.1752 40.7814 20.0955 39.8046 20.0955C37.9049 20.0955 37.5793 21.2667 37.4692 22.1124H33.8034C34.2367 17.6688 37.3053 17.041 40.2637 17.041C42.2993 17.041 46.0191 17.6688 46.0191 21.2386V29.0928H46.0214ZM42.304 24.867C41.9245 25.1669 41.2991 25.4128 39.725 25.6588C38.3125 25.9047 37.146 26.2584 37.146 27.8396C37.146 29.1747 38.1767 29.5847 38.9098 29.5847C40.5917 29.5847 42.304 28.4931 42.304 26.7222V24.867Z",
    fill: "#CE1422"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1189 31.9267H58.3733V23.1215C58.3733 22.0581 58.3195 20.2591 55.9396 20.2591C54.2811 20.2591 52.9975 21.4046 52.9975 23.6135V31.929H49.252V17.4248H52.8359V19.5517H52.8897C53.398 18.6803 54.4685 17.043 57.1693 17.043C59.9521 17.043 62.1165 18.7061 62.1165 21.8965V31.9267H62.1189Z",
    fill: "#CE1422"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3139 49.4219H68.115C68.5366 49.4219 68.6139 49.7334 68.6139 49.8716C68.6139 50.045 68.5249 50.1972 68.368 50.2487C68.4991 50.3073 68.5694 50.3542 68.5694 50.6516C68.5694 50.8835 68.5694 50.9421 68.6397 50.9679V51.01H68.2719C68.2508 50.9351 68.2368 50.8531 68.2368 50.6891C68.2368 50.4736 68.2227 50.3893 67.9791 50.3893H67.6371V51.01H67.3115V49.4219H67.3139ZM68.026 50.1199C68.1993 50.1199 68.2813 50.0614 68.2813 49.9044C68.2813 49.8201 68.2438 49.6959 68.0494 49.6959H67.6371V50.1199H68.026Z",
    fill: "#0874BB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9442 51.8533C67.0681 51.8533 66.3584 51.1412 66.3584 50.2675C66.3584 49.3914 67.0705 48.6816 67.9442 48.6816C68.8203 48.6816 69.53 49.3937 69.53 50.2675C69.53 51.1412 68.8179 51.8533 67.9442 51.8533ZM67.9442 48.9885C67.2391 48.9885 66.6676 49.5624 66.6676 50.2651C66.6676 50.9702 67.2415 51.5417 67.9442 51.5417C68.6493 51.5417 69.2208 50.9678 69.2208 50.2651C69.2208 49.5624 68.6469 48.9885 67.9442 48.9885Z",
    fill: "#0874BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZwan);
export default __webpack_public_path__ + "static/media/zwan.3fd667cead2a275cee0390f69bed7a16.svg";
export { ForwardRef as ReactComponent };